import { SearchOutlined } from '@ant-design/icons';
import { Col, Input, Row, Checkbox, Button, Modal, Tour } from 'antd';
import PayPeriodFilter from 'components/Global/PayPeriodFilter';
import { useDispatch, useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';
import styles from './index.module.scss';
import moment from 'moment';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import './index.scss';
import { useSearchParams } from 'react-router-dom';
import { getEmployeeCostAction } from 'redux/action/employeeCostAction';
import { AppDispatch } from 'redux/store';
import { putApi } from 'redux/apis';
import toast from 'react-hot-toast';

const SearchAndFilter = ({
	searchValue,
	onChangeSearchValue,
	onChangePayPeriodId,
	payPeriodId,
	closingDate,
	handleInactive,
	includeInactive,
	isConfigurationPermission,
	showEmployeeWithAllocationConfig,
	onChangeShowEmployeeWithAllocationConfig,
	handleShowPayPeriodCreationRefresh,
	isPayPeriodTourOpen,
	onClosePayPeriodTour,
}: // onSyncEmployee,
ISearchAndFilter) => {
	const dispatch = useDispatch<AppDispatch>();
	const [payPeriodData, setPayPeriodData] = useState<any>(null);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [queryParams, setQueryParams] = useSearchParams();

	const [isNewPayPeriod, setIsNewPayPeriod] = useState<string | null>(
		queryParams.get('isNewPayPeriod')
	);

	const selectedCompanyPermission = useSelector(
		(state: any) => state?.companies?.selectedCompanyDetails?.role?.permissions
	);

	const payPeriods = useSelector((state: any) => state?.payPeriods?.optionData);

	const isAddPayPeriodPermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Pay Period',
		permission: ['add'],
	});

	// const isAddEmployeeCostPermission = checkPermission(
	// 	selectedCompanyPermission,
	// 	{
	// 		permissionName: 'Employee Cost',
	// 		permission: ['add'],
	// 	}
	// );

	const isEditEmployeeCostPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Employee Cost',
			permission: ['edit'],
		}
	);

	const handleChangePayPeriodId = (id: any) => {
		setIsNewPayPeriod('false');
		onChangePayPeriodId && onChangePayPeriodId(id);
	};

	const handleChangeSearchValue = (value: any) => {
		onChangeSearchValue && onChangeSearchValue(value);
	};

	const handleInactiveEmployee = (e: CheckboxChangeEvent) => {
		handleInactive(e.target.checked);
	};

	const handleConfigOpen = () => {
		const _query: any = {
			openDrawer: 'true',
		};

		if (queryParams.get('payPeriodId')) {
			_query.payPeriodId = payPeriodId;
		}

		if (queryParams.get('isNewPayPeriod') === 'true') {
			_query.isNewPayPeriod = 'true';
		}

		setQueryParams(_query);
		localStorage.setItem('settings', 'Configurations');
	};

	useEffect(() => {
		if (payPeriods && payPeriods.length && payPeriodId) {
			const data = payPeriods.find((e: any) => e.id === payPeriodId);
			setPayPeriodData(data);
		} else {
			setPayPeriodData(null);
		}
	}, [payPeriodId, payPeriods]);

	const handleClearFilters = async () => {
		const response: any = await putApi(
			'/employee-cost/clearAllEmployeeCostValue',
			{
				payPeriodId,
				companyId: localStorage.getItem('companyId'),
			}
		);

		if (response.status === 200) {
			toast.success(response.data.message);
			dispatch(getEmployeeCostAction({ payPeriodId }));
		} else {
			toast.error('Something went wrong while resetting employee cost value');
		}

		// const response: any = dispatch(
		// 	clearAllEmployeeCostValue({
		// 		payPeriodId,
		// 	})
		// );
	};

	return (
		<>
		<div className={styles['search-filter']}>
			<div
				className={`${styles['search-filter__wrapper']} search-filter-custom cost-allocation-search-filter`}
			>
				<Row align="middle">
					<Col span={24}>
						<div className={styles['search-filter-bar']}>
							{/* All items are now siblings - no nested containers */}

							{/* Left side items (order: 1) */}
							<Input
								className={styles['search-filter__search']}
								placeholder="Search here..."
								style={{ fontSize: '12px', minHeight: '40px' }}
								suffix={<SearchOutlined />}
								onChange={(e) => handleChangeSearchValue(e.target.value)}
								size="large"
								value={searchValue}
								defaultValue={searchValue}
							/>

							<PayPeriodFilter
								payPeriodId={payPeriodId}
								onChangePayPeriodId={handleChangePayPeriodId}
								createNewPayPeriod={isAddPayPeriodPermission}
								defaultModalOpen={isNewPayPeriod === 'true'}
								handleShowPayPeriodCreationRefresh={
									handleShowPayPeriodCreationRefresh
								}
								onNextClick={() => {
									if (isPayPeriodTourOpen && onClosePayPeriodTour) {
										onClosePayPeriodTour();
									}
								}}
							/>

							{/* Status tags */}
							{payPeriodData?.isJournalPublished &&
							closingDate &&
							dayjs(payPeriodData?.endDate) >
								dayjs(closingDate).endOf('day') ? (
								<p
									className="published-tag status-published"
									style={{
										color: 'white',
										padding: '5px 10px',
										borderRadius: '8px',
										background: '#009049',
										fontSize: '16px',
									}}
								>
									Published
								</p>
							) : closingDate &&
							  dayjs(payPeriodData?.endDate) <
									dayjs(closingDate).endOf('day') ? (
								<p
									className="closed-tag status-closed"
									style={{
										color: 'white',
										padding: '5px 10px',
										borderRadius: '8px',
										background: 'red',
										fontSize: '16px',
									}}
								>
									Closed
								</p>
							) : null}

							{/* Config Link */}
							{payPeriodId && isConfigurationPermission && (
								<p
									className="config-link"
									onClick={handleConfigOpen}
								>
									Configurations
								</p>
							)}

							{/* Right side items (order: 2) - these will wrap individually */}
							{closingDate && (
								<p className="qbo-closing-date">
									QuickBooks Closing Date:{' '}
									{moment(closingDate).format('MM/DD/YYYY')}
								</p>
							)}

							{payPeriodId && (
								<>
									<Checkbox
										onChange={handleInactiveEmployee}
										checked={includeInactive}
										className={`include-inactive-checkbox ${
											!closingDate ? 'first-right-item' : ''
										}`}
									>
										<p style={{ fontSize: '12px' }}>Include Inactive</p>
									</Checkbox>

									<Checkbox
										onChange={(e) =>
											onChangeShowEmployeeWithAllocationConfig(e.target.checked)
										}
										checked={showEmployeeWithAllocationConfig}
										className="fixed-checkbox"
									>
										<p style={{ fontSize: '12px' }}>Fixed %</p>
									</Checkbox>

									{isEditEmployeeCostPermission && (
										<Button
											className={`clear-all-button ${styles['clear-all-button']}`}
											onClick={() =>
												Modal.confirm({
													title: (
														<span style={{ fontSize: '16px' }}>
															Reset Confirmation
														</span>
													),
													content: (
														<span style={{ fontSize: '12px' }}>
															This action will reset all employee cost values of
															each GL account to $0.
														</span>
													),
													okText: 'Yes, Reset',
													cancelText: 'Cancel',
													onOk: handleClearFilters,
													okButtonProps: {
														className: styles['confirm-ok-button'],
													},
													cancelButtonProps: {
														className: styles['cancel-button'],
													},
												})
											}
										>
											Clear All Values
										</Button>
									)}
								</>
							)}
						</div>
					</Col>
				</Row>
			</div>
		</div>

		<Tour
			rootClassName="pay-period-tour"
			open={isPayPeriodTourOpen}
			onClose={onClosePayPeriodTour}
			steps={[
				{
					title: 'Create Pay Period',
					description:
						'You can create a new pay period by clicking the Next button.',
					target: () => { const element = document.querySelector('[data-tour-target="pay-period-next-button"]'); 
						return element as HTMLElement; 
					}, 
					placement: 'top',
				},
			]}
		/>
		</>

		// <Row>
		// 	<Col className={styles['search-filter-main']}>
		// 		<div className={styles['search-filter-main-picker']}>
		// 			<div className={styles['search-filter-main-picker-left']}>
		// 				<Space className={styles['search-filter']}>
		// 					<Input
		// 						className={styles['search-filter__search']}
		// 						placeholder="Search here..."
		// 						// style={{ fontSize:'12px' }}
		// 						style={{ fontSize: '12px', minHeight: '40px' }}
		// 						suffix={<SearchOutlined />}
		// 						onChange={(e) => {
		// 							handleChangeSearchValue(e.target.value);
		// 						}}
		// 						size="large"
		// 						value={searchValue}
		// 						defaultValue={searchValue}
		// 					/>
		// 				</Space>
		// 				<PayPeriodFilter
		// 					payPeriodId={payPeriodId}
		// 					onChangePayPeriodId={(value) => handleChangePayPeriodId(value)}
		// 					createNewPayPeriod={isAddPayPeriodPermission}
		// 					defaultModalOpen={
		// 						isNewPayPeriod == 'true' ? Boolean(isNewPayPeriod) : false
		// 					}
		// 					handleShowPayPeriodCreationRefresh={
		// 						handleShowPayPeriodCreationRefresh
		// 					}
		// 				/>
		// 				{payPeriodData?.isJournalPublished &&
		// 				closingDate &&
		// 				dayjs(payPeriodData?.endDate) > dayjs(closingDate).endOf('day') ? (
		// 					<p
		// 						style={{
		// 							color: 'white',
		// 							padding: '5px 10px',
		// 							borderRadius: '8px',
		// 							background: '#009049',
		// 							fontSize: '18px',
		// 						}}
		// 					>
		// 						Published
		// 					</p>
		// 				) : closingDate &&
		// 				  dayjs(payPeriodData?.endDate) <
		// 						dayjs(closingDate).endOf('day') ? (
		// 					<p
		// 						style={{
		// 							color: 'white',
		// 							padding: '5px 10px',
		// 							borderRadius: '8px',
		// 							background: 'red',
		// 							fontSize: '18px',
		// 						}}
		// 					>
		// 						Closed
		// 					</p>
		// 				) : null}

		// 				{payPeriodId && isConfigurationPermission ? (
		// 					<p className="config-link" onClick={() => handleConfigOpen()}>
		// 						Configurations
		// 					</p>
		// 				) : null}
		// 			</div>
		// 			<div
		// 				className={`${styles['search-filter-main-picker-right']} search-filter-main-picker-right`}
		// 			>
		// 				{closingDate ? (
		// 					<p style={{ color: '#818181', fontSize: '12px' }}>
		// 						QuickBooks Closing Date:{' '}
		// 						{moment(closingDate).format('MM/DD/YYYY')}
		// 					</p>
		// 				) : null}
		// 				{payPeriodId && (
		// 					<>
		// 						<Checkbox
		// 							onChange={handleInactiveEmployee}
		// 							checked={includeInactive}
		// 						>
		// 							<p style={{ fontSize: '12px' }}>Include Inactive</p>
		// 						</Checkbox>
		// 						<Checkbox
		// 							onChange={(e) =>
		// 								onChangeShowEmployeeWithAllocationConfig(e.target.checked)
		// 							}
		// 							checked={showEmployeeWithAllocationConfig}
		// 						>
		// 							<p style={{ fontSize: '12px' }}>Fixed %</p>
		// 						</Checkbox>

		// 						{isEditEmployeeCostPermission && (
		// 							<Button
		// 								className={styles['clear-all-button']}
		// 								onClick={() => {
		// 									Modal.confirm({
		// 										title: (
		// 											<span style={{ fontSize: '16px' }}>
		// 												Reset Confirmation
		// 											</span>
		// 										),
		// 										// title: 'Reset Confirmation',
		// 										content: (
		// 											<span style={{ fontSize: '12px' }}>
		// 												This action will reset all employee cost values of
		// 												each GL account to $0.
		// 											</span>
		// 										),
		// 										// content:
		// 										// 	'This action will reset all employee cost values of each GL account to $0.',
		// 										okText: 'Yes, Reset',
		// 										cancelText: 'Cancel',
		// 										onOk: handleClearFilters,
		// 										okButtonProps: {
		// 											className: styles['confirm-ok-button'],
		// 										},
		// 										cancelButtonProps: {
		// 											className: styles['cancel-button'],
		// 										},
		// 									});
		// 								}}
		// 							>
		// 								Clear All Values
		// 							</Button>
		// 						)}
		// 					</>
		// 				)}
		// 			</div>
		// 		</div>
		// 	</Col>
		// </Row>
	);
};

export default SearchAndFilter;

interface ISearchAndFilter {
	searchValue: any;
	onChangeSearchValue: any;
	// dateRangeDateHandler: any;
	// payPeriodDateRange: any;
	// onSavePayPeriod: any;
	onChangePayPeriodId: any;
	payPeriodId: any;
	onSyncEmployee: any;
	currentDatePayPeriodId: string;
	closingDate: string | null;
	handleInactive: (e: boolean) => void;
	includeInactive: boolean;
	isConfigurationPermission: boolean;
	showEmployeeWithAllocationConfig: boolean;
	onChangeShowEmployeeWithAllocationConfig: (e: boolean) => void;
	handleShowPayPeriodCreationRefresh: any;
	isPayPeriodTourOpen: boolean;
	onClosePayPeriodTour: () => void;
}
